module.exports = __webpack_public_path__ + "img/linux.352207bd.svg";